// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__1n5Uh","loader":"loader_loader__5klEb"};